import { ActionService } from 'dashboard-services/services';

export const compareDataScienceActions = (() => {

  const ON_CHANGE = 'ON_CHANGE_COMPARE_PIPELINES_DATA_SCIENCE'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const ON_CHANGE_LOCAL_TASKS_PARAM = 'ON_CHANGE_LOCAL_TASKS_PARAM_COMPARE_PIPELINES_DATA_SCIENCE'
  const onChangeLocalTasksParam = ActionService.makeActionCreator(ON_CHANGE_LOCAL_TASKS_PARAM, 'value', 'name', 'taskId')

  return {
    onChange,
    ON_CHANGE,
    ON_CHANGE_LOCAL_TASKS_PARAM,
    onChangeLocalTasksParam
  }
})()